import { initDatadog } from '@ecrm-datadog'
import { environment } from './app/utils/environment'

let initialised = false

export const initDd = () => {
  if(initialised) return
  initDatadog({
    applicationId: environment.ddApplicationIdAgent,
    clientToken: environment.ddClientTokenAgent,
    service: 'agent-portal',
    env: environment.environment,
  })
  initialised = true
}